import Activity from '@/models/Activity';

export default class IdleState extends Activity {
  constructor({ reference }) {
    super({ reference });
  }

  execute() {
    this.reference.decreaseFatigueLevel();
  }
}
